<template>
  <div class="tab-btn" :class="{ 'tab-btn_colored': colored, 'tab-btn_selected': selected }">
    <div v-if="index > -1" class="tab-btn__index">{{ index + 1 }}.</div>
    <slot name="title">
      <div class="tab-btn__title">{{ title }}</div>
    </slot>
    <div v-if="badge" class="tab-btn__badge" :class="{ 'tab-btn__badge_blue': blue }">
      {{ badge }}
    </div>
    <v-menu v-if="$slots.default" left offset-y transition="slide-y-transition">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" class="tab-btn__chevron" v-on="on">
          <Icon type="chevron-down" :color="colored ? 'oncolor' : 'secondary'" size="16" />
        </div>
      </template>
      <slot />
    </v-menu>
  </div>
</template>

<script>
  import { VMenu } from 'vuetify/lib';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'Tab',
    components: {
      Icon,
      VMenu,
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      index: {
        type: Number,
        default: -1,
      },
      badge: {
        type: [String, Number],
        default: '',
      },
      colored: Boolean,
      selected: Boolean,
      blue: Boolean,
    },
  };
</script>
